var map = {
	"./_template.jsx": 387,
	"./docs/Administrable.json": 1082,
	"./docs/BasicToken.json": 1083,
	"./docs/BurnableCentralBank.json": 1084,
	"./docs/BurnableErc20.json": 1085,
	"./docs/Burner.json": 1086,
	"./docs/Bytes.json": 1087,
	"./docs/BytesUtilsMock.json": 1088,
	"./docs/CentralBank.json": 1089,
	"./docs/CurrencyContract.json": 1090,
	"./docs/Destructible.json": 1091,
	"./docs/ERC20.json": 1092,
	"./docs/ERC20Basic.json": 1093,
	"./docs/ERC20OMGLike.json": 1094,
	"./docs/FeeCollector.json": 1095,
	"./docs/KyberMock.json": 1096,
	"./docs/KyberNetwork.json": 1097,
	"./docs/Migrations.json": 1098,
	"./docs/Ownable.json": 1099,
	"./docs/Pausable.json": 1100,
	"./docs/RequestBitcoinNodesValidation.json": 1101,
	"./docs/RequestCore.json": 1102,
	"./docs/RequestERC20.json": 1103,
	"./docs/RequestEthereum.json": 1104,
	"./docs/RequestOMG.json": 1105,
	"./docs/SafeMath.json": 1106,
	"./docs/SafeMathInt.json": 1107,
	"./docs/SafeMathIntMock.json": 1108,
	"./docs/SafeMathUint8.json": 1109,
	"./docs/SafeMathUint96.json": 1110,
	"./docs/Signature.json": 1111,
	"./docs/StandardToken.json": 1112,
	"./docs/TestRequestPaymentStuckAssert.json": 1113,
	"./docs/TestRequestPaymentStuckNonPayable.json": 1114,
	"./docs/TestRequestPaymentStuckRevert.json": 1115,
	"./docs/TestToken.json": 1116,
	"./docs/TestTokenOMGLike.json": 1117,
	"./docs/_template.jsx": 1118,
	"./index.md": 1119
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1081;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|jsx|js|markdown|md|ipynb|html|json|yaml|toml)$
// module id = 1081
// module chunks = 0